// extracted by mini-css-extract-plugin
export default {"banner":"cyoPzfo","content":"fgBzI0z","image":"ky_LbB6","textContainer":"_bQRsvk","headline":"IPsIpf7","text":"ZRMZoBq"};